globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '../button';
import { Title } from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerCollaboratorFeedbackScreen(_ref) {
  var title = _ref.title,
      cta = _ref.cta,
      content = _ref.content,
      _ref$iconVariant = _ref.iconVariant,
      iconVariant = _ref$iconVariant === void 0 ? 'success' : _ref$iconVariant,
      noTopIcon = _ref.noTopIcon;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [noTopIcon ? null : iconVariant === 'success' ? /*#__PURE__*/_jsx(_StyledCheckCircleIcon, {}) : /*#__PURE__*/_jsx(_StyledInformationCircleIcon, {}), /*#__PURE__*/_jsx(Title, {
      fontWeight: "semibold",
      fontSize: "large",
      textColor: "neutral-700",
      twStyle: {
        "marginTop": "2rem",
        "fontSize": "1.125rem",
        "lineHeight": "1.75rem",
        "@media (min-width: 1024px)": {
          "fontSize": "1.25rem",
          "lineHeight": "1.75rem"
        }
      },
      children: title
    }), content && /*#__PURE__*/_jsx(_StyledContentWrapper, {
      children: content
    }), /*#__PURE__*/_jsx(_StyledContentWrapper2, {
      children: cta && /*#__PURE__*/_jsx(Button, {
        onClick: cta === null || cta === void 0 ? void 0 : cta.onClick,
        fullwidth: true,
        children: cta === null || cta === void 0 ? void 0 : cta.title
      })
    })]
  });
}
export default EmployerCollaboratorFeedbackScreen;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "employer-collaborator-feedback-screen__Wrapper",
  componentId: "sc-1s6tec6-0"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "maxWidth": "640px",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "textAlign": "center"
});

var ContentWrapper = /*#__PURE__*/_styled.p.withConfig({
  displayName: "employer-collaborator-feedback-screen__ContentWrapper",
  componentId: "sc-1s6tec6-1"
})(["", ""], {
  "maxWidth": "576px",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(102 102 118 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "minWidth": "576px"
  }
});

var _StyledContentWrapper2 = /*#__PURE__*/_styled(ContentWrapper).withConfig({
  displayName: "employer-collaborator-feedback-screen___StyledContentWrapper2",
  componentId: "sc-1s6tec6-2"
})({
  "marginTop": "4rem"
});

var _StyledContentWrapper = /*#__PURE__*/_styled(ContentWrapper).withConfig({
  displayName: "employer-collaborator-feedback-screen___StyledContentWrapper",
  componentId: "sc-1s6tec6-3"
})({
  "marginTop": "2rem"
});

var _StyledCheckCircleIcon = /*#__PURE__*/_styled(CheckCircleIcon).withConfig({
  displayName: "employer-collaborator-feedback-screen___StyledCheckCircleIcon",
  componentId: "sc-1s6tec6-4"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(0 119 64 / var(--tw-text-opacity))"
});

var _StyledInformationCircleIcon = /*#__PURE__*/_styled(InformationCircleIcon).withConfig({
  displayName: "employer-collaborator-feedback-screen___StyledInformationCircleIcon",
  componentId: "sc-1s6tec6-5"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 28 51 / var(--tw-text-opacity))"
});